import React from 'react';
import InputMask from 'react-input-mask';
import { Input } from '../FormInput/styles';

export default function InputMaskCustom({
  label,
  placeholder,
  value,
  disabled,
  mask,
  onChange,
  type,
  maxLength,
  validate,
  onBlur,
  helperText,
  InputProps,
  validation,
  color,
  ...props
}) {
  return (
    <InputMask
      {...props}
      helperText={helperText}
      mask={mask}
      disabled={disabled}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
    >
      {(inputProps) => (
        <Input
          {...inputProps}
          fullWidth
          value={value}
          helperText={helperText}
          type={type}
          label={label}
          disabled={disabled}
          maxLength={maxLength}
          placeholder={placeholder}
          InputProps={InputProps}
          color={
            validation?.errors && validation?.touched
              ? color
              : '1px solid #ced4da'
          }
        />
      )}
    </InputMask>
  );
}
